import DemoPageWrapper from "../../utils/DemoPageWrapper";
import Demo from "./demo";
import DemoSource from "!!raw-loader!./demo.vue";
const config = {
  props: [
    {
      prop: "dropdownProps",
      description: "dropdown prop对象",
      type: "Object",
      default: "{}"
    },
    {
      prop: "menuProps",
      description: "menu prop 对象",
      type: "Object",
      default: "{}"
    }
  ],
  events: [],
  methods: [],
  slots: []
};
export default DemoPageWrapper(Demo, DemoSource, config);
